import { Component, Injector, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FindControlIdService } from 'webcommon/legacy-common';
import { ApAlertService, ApNotificationService } from 'webcommon/core-ui';
import { FcMapNetworkResponse } from 'webcommon/shared';

import { MapInsuranceNetworkService } from './map-insurance-network.service';
import { FcItemListBaseComponent, FcListValidationService } from '../../generic';

@Component({
    providers: [ApAlertService, FcListValidationService],
    selector: 'ap-map-insurance-network',
    styleUrls: ['./map-insurance-network.component.less'],
    templateUrl: './map-insurance-network.component.html',
})
export class MapInsuranceNetworkComponent extends FcItemListBaseComponent {
    @Input() baseId: string;
    @Input() isMapByProvider: boolean;
    @Input() providedInsurancePlanUid?: string;

    public isOpenedAsModal = false;
    public selectedToProviderPks: string[] = [];
    public selectedInsurancePlanPks: string[] = [];
    public isDeleteAllMappingFromDatabase = false;
    public isClearSelectedMappings = false;
    public isSubmitted = false;

    // Form Controls
    public toProviderUidControl = new FormControl(['']);
    public insurancePlanUidControl = new FormControl(['']);

    public form: FormGroup = new FormGroup({
        providersUid: this.toProviderUidControl,
        insurancePlanUid: this.insurancePlanUidControl,
    });

    constructor(
        injector: Injector,
        public mapInsuranceNetworkService: MapInsuranceNetworkService,
        public apNotificationService: ApNotificationService
    ) {
        super(injector);
    }

    private clearSelectedPks(): void {
        this.selectedToProviderPks = [];
        this.selectedInsurancePlanPks = [];
    }

    public onClearSelectedMappings(): void {
        if (this.selectedInsurancePlanPks.length > 0 && this.selectedToProviderPks.length > 0) {
            this.isClearSelectedMappings = true;
        }
        if (this.isMapByProvider) {
            this.selectedInsurancePlanPks = [];
        } else {
            this.selectedToProviderPks = [];
        }
    }

    public onClearAllMappings(): void {
        this.isDeleteAllMappingFromDatabase = true;
        this.clearSelectedPks();
    }

    public onMapBy(): void {
        this.clearSelectedPks();
        this.isMapByProvider = !this.isMapByProvider;
    }

    public disableSaveButton(): boolean {
        return this.mapInsuranceNetworkService
            .disableSaveButton(
                this.isOpenedAsModal,
                this.form,
                this.selectedToProviderPks,
                this.selectedInsurancePlanPks,
                this.isDeleteAllMappingFromDatabase,
                this.isClearSelectedMappings);
    }

    public onProviderDataPopulate() {
        if (this.selectedToProviderPks[0]) {
            this.mapInsuranceNetworkService
                .getNetworkProviderItems(FindControlIdService.ViewProvider, this.selectedToProviderPks[0])
                .pipe(this.takeUntilDestroy())
                .subscribe((insurancePlans: string[]) => {
                    if (insurancePlans) {
                        this.selectedInsurancePlanPks = insurancePlans;
                        this.form.markAsPristine();
                    }
                });
        } else {
            this.clearSelectedPks();
        }
    }

    public onInsurancePlanDataPopulate() {
        if (this.selectedInsurancePlanPks[0]) {
            this.mapInsuranceNetworkService
                .getNetworkProviderItems(FindControlIdService.ViewPayerPlan, this.selectedInsurancePlanPks[0])
                .pipe(this.takeUntilDestroy())
                .subscribe((providers: string[]) => {
                    if (providers) {
                        this.selectedToProviderPks = providers;
                        this.form.markAsPristine();
                    }
                });
        } else {
            this.clearSelectedPks();
        }
    }

    public onCancel() {
        this.clearSelectedPks();
        this.isDeleteAllMappingFromDatabase = false;
        this.isClearSelectedMappings = false;
    }

    public onSave(): void {
        this.isSubmitted = true;
        const successTitle = 'Success';
        const successMessage = 'has been updated';
        const errorTitle = 'Something went wrong';
        const errorMessage = 'Your change could not be saved due to an unknown error';
        if (this.selectedToProviderPks.length > 0 && this.selectedInsurancePlanPks.length > 0 || this.isClearSelectedMappings) {
            if (!this.isMapByProvider) {
                this.mapInsuranceNetworkService.updateNetworkItems(FindControlIdService.ViewPayerPlan,
                    this.selectedInsurancePlanPks[0],
                    this.selectedToProviderPks)
                    .pipe(this.takeUntilDestroy())
                    .subscribe((response: FcMapNetworkResponse) => {
                        if (response.IsSuccess) {
                            this.clearSelectedPks();
                            this.apNotificationService.success('Insurance Plan ' + successMessage, successTitle, 3000);
                        }
                    },
                        () => {
                            this.apNotificationService.error(errorMessage, errorTitle, 3000);
                        });
            } else if (this.isMapByProvider) {
                this.mapInsuranceNetworkService.updateNetworkItems(FindControlIdService.ViewProvider,
                    this.selectedToProviderPks[0],
                    this.selectedInsurancePlanPks)
                    .pipe(this.takeUntilDestroy())
                    .subscribe((response: FcMapNetworkResponse) => {
                        if (response.IsSuccess) {
                            this.clearSelectedPks();
                            this.apNotificationService.success('Provider ' + successMessage, successTitle, 3000);
                        }
                    },
                        () => {
                            this.apNotificationService.error(errorMessage, errorTitle, 3000);
                        });
            }
        }
        if (this.isDeleteAllMappingFromDatabase) {
            this.mapInsuranceNetworkService.deleteNetworksItem(FindControlIdService.ViewPayerPlan)
                .pipe(this.takeUntilDestroy())
                .subscribe((response: FcMapNetworkResponse) => {
                    if (response.IsSuccess) {
                        this.clearSelectedPks();
                        this.apNotificationService.success('Clear all mappings has been saved', successTitle, 3000);
                    }
                },
                    () => {
                        this.apNotificationService.error(errorMessage, errorTitle, 3000);
                    });
        }
        this.isDeleteAllMappingFromDatabase = false;
        this.isClearSelectedMappings = false;
    }
}
